var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',[_vm._v(_vm._s(_vm.siteName)+" © 2025")]),_c('div',[_vm._v("地址：海南省三亚市崖州区兴滨三横路椰岛阳光花园A区立宇办公楼三楼 | 电话：15308032337")]),_c('div',[_vm._v("备案号："+_vm._s(_vm.icpInfo))])])
}
var staticRenderFns = []

export { render, staticRenderFns }